import Location from './components/location'
import MaskedInput from '../MaskedInput'

export default {
  name: 'user-profiles',
  components: {Location, MaskedInput},
  props: {
    application: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      currentTabId: this.application.PROFILES.length > 0 ? this.application.PROFILES[0].ID : -1,
      isAjax: false,
      errors: [],
      newPersonType: 1
    }
  },
  created: function () {
    console.log(this.application)
  },
  methods: {
    delProfile: function(id){
      console.log(id,"ID");
      this.isAjax = true
      if(confirm("Вы уверены что хотите удалить профиль? Профиль будет удален из списка без возможности восстановления.")) {



        this.$http.post('/ajax/del_profile.php', {id: id}).then(res => {
          this.isAjax = false
          if (res.data.errors.length > 0) {
            this.errors = res.data.errors
            console.error(res.data.errors)
          } else {
            window.location.reload()
            console.log(res.data.data)
          }
        })
      }
    },
    onSubmit: function (event) {
      let form = event.target

      let formData = new FormData(form)
      this.isAjax = true
      this.$http.post(form.action, formData).then(res => {
        this.isAjax = false
        if (res.data.errors.length > 0) {
          this.errors = res.data.errors
          console.error(res.data.errors)
        } else {
          window.location.reload()
          console.log(res.data.data)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vue/components/userProfiles/script.js